<template>
  <div class="snackbar-container">
    <transition-group name="snackbar-transition" appear>
      <snackbar
        v-for="{ id, state, header, text } in messagesReversed"
        class="snackbar-container__item"
        :key="id"
        :state="state"
        :header="header"
        :text="text"
        @click="emits('dismiss', id)"
      >
      </snackbar>
    </transition-group>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import Snackbar from '@/components/snackbar/Snackbar.vue'
import { SnackbarMessage } from '@/store/application-store'

interface Props {
  messages: SnackbarMessage[]
}
const props = defineProps<Props>()

// Messages are rendered from bottom to top
const messagesReversed = computed(() => [...props.messages].reverse())

interface Emits {
  (event: 'dismiss', messageId: number): void
}
const emits = defineEmits<Emits>()

</script>
<style lang="scss">
.snackbar-container {
  $padding: 24px; // Not actually specced
  display: flex;
  flex-flow: column nowrap;
  padding: $padding;
  gap: 24px;
  overflow: hidden; // This is to make sure the snackbars when entering/leaving, do not create scrollbars

  .snackbar-transition {
    // Enter from and leave from the right edge of the container
    &-enter-from,
    &-leave-to {
      // Kind of sucks - but if we have padding/margin 100% doesn't animate the element all the way across. This is
      // because 100% in this context means 100% of the element that's affected, not the parent.
      transform: translateX(calc(100% + $padding));
    }

    &-leave-active,
    &-enter-active,
    &-move {
      transition: all 400ms $animationCurve;
    }
  }
}
</style>
